export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["PENDING"] = "PENDING";
    NotificationStatus["SENT"] = "SENT";
    NotificationStatus["DELIVERED"] = "DELIVERED";
    NotificationStatus["FAILED"] = "FAILED";
})(NotificationStatus || (NotificationStatus = {}));
export var NotificationPriority;
(function (NotificationPriority) {
    NotificationPriority["LOW"] = "LOW";
    NotificationPriority["NORMAL"] = "NORMAL";
    NotificationPriority["HIGH"] = "HIGH";
})(NotificationPriority || (NotificationPriority = {}));
export var NotificationCategory;
(function (NotificationCategory) {
    NotificationCategory["TRANSACTION"] = "TRANSACTION";
    NotificationCategory["SECURITY"] = "SECURITY";
    NotificationCategory["ACCOUNT"] = "ACCOUNT";
    NotificationCategory["MARKETING"] = "MARKETING";
    NotificationCategory["SYSTEM"] = "SYSTEM";
    NotificationCategory["KYC"] = "KYC";
    NotificationCategory["CARD"] = "CARD";
})(NotificationCategory || (NotificationCategory = {}));
export var PushTokenStatus;
(function (PushTokenStatus) {
    PushTokenStatus["WORKING"] = "WORKING";
    PushTokenStatus["FAILED"] = "FAILED";
    PushTokenStatus["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    PushTokenStatus["UNKNOWN"] = "UNKNOWN";
})(PushTokenStatus || (PushTokenStatus = {}));
export var PushHistorySource;
(function (PushHistorySource) {
    PushHistorySource["MANUAL"] = "MANUAL";
    PushHistorySource["BROADCAST"] = "BROADCAST";
    PushHistorySource["SYSTEM"] = "SYSTEM";
})(PushHistorySource || (PushHistorySource = {}));
export const EXPO_PUSH_TOKEN_REGEX = /^ExponentPushToken\[[a-zA-Z0-9_-]+\]$/;
export function isValidExpoPushToken(token) {
    return EXPO_PUSH_TOKEN_REGEX.test(token);
}
//# sourceMappingURL=notification.types.js.map